import { render, staticRenderFns } from "./Disambigview.vue?vue&type=template&id=19ee5afc"
import script from "./Disambigview.vue?vue&type=script&lang=js"
export * from "./Disambigview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports